import { createSelector } from 'reselect'
import { ReduxState } from '@batical/reducer/src/reducers'

// eslint-disable-next-line import/prefer-default-export
export const selectCalculLink = () => {
  return createSelector(
    (state: ReduxState) => state.calculNav.calculLink,
    (_: ReduxState, key: string) => key,
    (calculLink, key: string) => {
      return calculLink[key]
    }
  )
}
